import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        page: {
            total: 0,
            records: []
        },
        pageSearch: {
            current: 1,
            size: 10,
            search: {
                role_id: null,
                like_name: null,
                like_description: null,
                status: true,
            }
        }
    },
    getters: {
        ['RoleUserListGetPageSearchSearchRoleId'](state){
            return state.pageSearch.search.role_id;
        },
        ['RoleUserListGetPageSearch'](state) {
            return state.pageSearch;
        },
        ['RoleUserListGetPageCurrent'](state) {
            return state.pageSearch.current;
        },
        ['RoleUserListGetPageSize'](state) {
            return state.pageSearch.size;
        },
        ['RoleUserListGetPageTotal'](state) {
            return state.page.total;
        },
    },
    mutations: {
        ['RoleUserListSetLoading'](state, loading) {
            state.loading = loading;
        },
        ['RoleUserListSetPage'](state, page) {
            state.page = page;
        },
        ['RoleUserListSetPageSearch'](state, pageSearch) {
            state.pageSearch = pageSearch;
        },
        ['RoleUserListSetPageSearchSearch'](state, pageSearchSearch) {
            state.pageSearch.search = pageSearchSearch;
        },
        ['RoleUserListSetPageSearchSearchRoleId'](state, roleId) {
            state.pageSearch.search.role_id = roleId;
        },
        ['RoleUserListSetPageCurrent'](state, pageCurrent) {
            state.pageSearch.current = pageCurrent;
        },
        ['RoleUserListSetPageSize'](state, pageSize) {
            state.pageSearch.size = pageSize;
        }
    },
    actions: {
        async queryByPage({commit}, params) {
            commit('RoleUserListSetLoading', true);
            commit('RoleUserListSetPageSearch', params);
            try {
                let result = await OrganizationServer.userRole.userPage(params);
                if (result.data.code === '200') {
                    result.data.data.records.forEach(
                        user => {
                            if (user.description === null) {
                                user.description = '-';
                            }
                        }
                    )
                    commit('RoleUserListSetPage', result.data.data);
                }
                commit('RoleUserListSetLoading', false);
            } catch (e) {
                console.log(e.message);
                commit('RoleUserListSetLoading', false);
                throw e;
            }
        }
    }
}
